module.exports = __webpack_public_path__ + "static/media/signup.a713c874.svg";